import moment from 'moment';

import 'moment/locale/de';
import 'moment/locale/fr';
import 'moment/locale/it';

export const setMomentDefaultLocale = (language : string) : void => {
    moment.locale(language);
};